// extracted by mini-css-extract-plugin
export var discountBox = "DiscountTag-module--discountBox--1cae4";
export var discountValue = "DiscountTag-module--discountValue--45f91";
export var logoHead = "DiscountTag-module--logoHead--add07";
export var small = "DiscountTag-module--small--81b3b";